<script lang="ts" setup>
import { computed, type HTMLAttributes } from "vue";
import type { StepperDescriptionProps } from "reka-ui";
import { StepperDescription, useForwardProps } from "reka-ui";
import { twMerge } from "tailwind-merge";

const props = defineProps<StepperDescriptionProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwarded = useForwardProps(delegatedProps);
</script>

<template>
  <StepperDescription
    v-slot="slotProps"
    v-bind="forwarded"
    :class="twMerge('text-xs text-muted-foreground', props.class)"
  >
    <slot v-bind="slotProps" />
  </StepperDescription>
</template>
